import { DashboardLayout } from "../../../../layouts/DashboardLayout";
import { usePropertyViewCount } from "../hooks/usePropertyViewCount";
import { PropertyDetailWrapper } from "./PropertyDetailWrapper";

interface AuctionPropertyDetailsPropInterface {
  propertyData: any;
  defaultLocation: any;
}

export const AuctionPropertyDetails: React.FC<
  AuctionPropertyDetailsPropInterface
> = ({ propertyData, defaultLocation }) => {
  usePropertyViewCount({ property: propertyData });
  return (
    <DashboardLayout>
      <PropertyDetailWrapper
        propertyData={propertyData}
        defaultLocation={defaultLocation}
        propertyType="auction_property"
      />
    </DashboardLayout>
  );
};
